import { useIsLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import { useQuery as usePromoBannerQuery } from "@faire/web-api--source/endpoints/www/api/messaging/promo_banner/get-hooks";

export const useGetImpBanners = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { data: promoBannerResult, isLoading: isPromoBannerLoading } =
    usePromoBannerQuery(undefined, {
      enabled: isLoggedInRetailer,
      refetchOnMount: false,
    });

  return {
    inProductMessagingBanners: promoBannerResult?.banner_messages,
    isPromoBannerLoading,
  };
};
